module.exports = __webpack_public_path__ + "img/blue-tick.2797b466.svg";